class FacebookLiveUser {
  id: string;

  broadcastId: string;

  pageId: string;

  userId: string;

  userName: string;

  timestamp: Date;

  constructor({
    id,
    broadcastId,
    pageId,
    userId,
    userName,
    timestamp,
  }: {
    id: string;
    broadcastId: string;
    pageId: string;
    userId: string;
    userName: string;
    timestamp: Date;
  }) {
    this.id = id;
    this.broadcastId = broadcastId;
    this.pageId = pageId;
    this.userId = userId;
    this.userName = userName;
    this.timestamp = timestamp;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromApiResponse(columns: string[], rows: any[][]): FacebookLiveUser[] {
    if (rows.length === 0) {
      return [];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return rows.map((row: any[]) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const v: any = {};
      columns.forEach((column, index) => {
        const camelCaseKey = column.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
        if (row[index] && camelCaseKey === 'timestamp') {
          v[camelCaseKey] = new Date(row[index]);
        } else {
          v[camelCaseKey] = row[index];
        }
      });
      return new FacebookLiveUser(v);
    });
  }
}

export default FacebookLiveUser;
